import { render, staticRenderFns } from "./HasCableTv.vue?vue&type=template&id=ffaf55ae&"
import script from "./HasCableTv.vue?vue&type=script&lang=ts&"
export * from "./HasCableTv.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports